import axios from 'axios';
import { host } from './config';
import ElementUI from 'element-ui';
import cookie from "js-cookie";
import router from '../router'

var instance = axios.create({
    baseURL: host,
    timeout: 5000,
});

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // if(config.url === '/zs/common/uploadPicture'){
      
        // config.headers['Content-Type']='multipart/form-data'
    // }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
    // 404
    if (response.data.respCode == 3) {
          // this.$message.error('token过期')
          ElementUI.MessageBox.confirm('您的登陆已失效，请重新登陆!')
            .then(_ => {            
              cookie.remove("Flag",{path:''});
              cookie.remove("user",{path:''});
              sessionStorage.removeItem("Flag")
              sessionStorage.removeItem("user")
              router.replace({
                  path: '/login' // 到登录页重新获取token
              })
            //   location.reload()
            })
        }
    //     console.log('+++++++++++++++++++++++++++++++++++++');
    // 对响应数据做点什么
    return response;
}, function (error) {


    
    // 对响应错误做点什么
    return Promise.reject(error);
});

export default instance


// WEBPACK FOOTER //
// ./src/api/request.js